import { getCellByPipelineId, isRecordsLikeCell } from '@/core/cell';
import { getFinalState, PipelineStateContext } from '@/explore/pipeline/state';
import { Exploration } from '@/explore/types';

export const getCellOptions = (exploration: Exploration) =>
  exploration.view.cells.filter(isRecordsLikeCell).map((cell) => ({
    value: cell.pipeline.pipelineId,
    label: cell.title ?? '',
  }));

export const getFieldOptions = (pipelineId: string, ctx: PipelineStateContext) => {
  const cell = getCellByPipelineId(ctx.exploration.view.cells, pipelineId);
  if (cell === undefined) {
    return [];
  }

  return getFinalState(cell.pipeline, ctx)
    .fields.filter(({ type }) => type !== 'Boolean' && type !== 'Date')
    .map((field) => ({
      value: field.key,
      label: field.name,
    }));
};
